export const ApiQueryEndpoint = {
  BASKET: {
    GET_BASKET: { endpoint: 'cart_content' },
    GET_BASKET_TOTAL_QUANTITE: { endpoint: 'cart_content_lite' },
    IMPORT_CSV_CHECK: { endpoint: 'basket_import_csv' },
    IMPORT_CSV_ADD: { endpoint: 'basket_import_csv', method: 'PUT' },
  },
  CATALOG: {
    PRODUCTS: { endpoint: 'products' },
    // searchProducts / searchProductsFacet migres du resolver GraphQL vers REST
    // (lot 7). Les deux pointent sur l'endpoint CS-Cart `products` : la
    // difference (get_only_filters) est portee par les params (cf.
    // lib/searchProductsTransform.buildSearchParams via getFilters).
    SEARCH_PRODUCTS: { endpoint: 'products' },
    SEARCH_PRODUCTS_FACET: { endpoint: 'products' },
    // Autocomplete Elasticsearch : suggestions
    // produits/marques/requetes -> entite CS-Cart pharme_search_suggest
    SEARCH_SUGGEST: { endpoint: 'search_suggest' },
    // Recommend interne : "aussi achete" / best-sellers vendeur / similaires -> entite CS-Cart
    // pharme_recommend (params type, product_id, company_id, limit)
    RECOMMEND: { endpoint: 'recommend' },
    BRANDS: { endpoint: 'brands' },
    CATEGORIES: { endpoint: 'categories' },
    PRODUCT_DETAIL: { endpoint: 'products/:id' },
    CATEGORY_DETAIL: { endpoint: 'categories/:id' },
    VARIANT_DETAIL: { endpoint: 'variants/:id' },
    SEO: { endpoint: 'seo' },
    GET_PRODUCTS_SORTING: { endpoint: 'products_sorting' },
    GET_PLANNING_SHIPPING_DATES: { endpoint: 'planning_shipping_dates' },
    CAN_POST_PRODUCT_REVIEW: { endpoint: '/catalog/products/:productId/reviews/authorized' },
    GET_PRODUCT_REVIEW: { endpoint: '/catalog/products/:productId/reviews' },
  },
  CMS: {
    GET_BANNERS: { endpoint: 'banners?items_per_page=50' },
    GET_MENUS: { endpoint: 'menus' },
    GET_PAGE_SEO: { endpoint: 'seo?type=a' },
    GET_PAGE: { endpoint: 'pages/:pageId' },
  },
  COMMUNICATION: {
    GET_UNREAD_COUNT: { endpoint: 'communication' },
    GET_MESSAGES: { endpoint: 'communication/:order_id' },
    GET_ALL_THREADS: { endpoint: 'communication?all=1' },
  },
  DIVISIONS: {
    GET_DIVISIONS: { endpoint: 'countries_states' },
  },
  STOREFRONT: {
    GET_SOCIETY_INFO: { endpoint: 'storefront' },
  },
  ORDERS: {
    GET_LIST: { endpoint: 'orders?items_per_page=50&get_company_name=true' },
    GET_GAINS: { endpoint: 'order_gains/:order_id' },
    GET_ORDERS: { endpoint: 'orders' },
    GET_ORDER_DETAIL: { endpoint: 'orders/:orderId' },
  },
  TRANSLATION: {},
  LGO: {
    // Refus de commandes LGO du pharmacien connecte (entite CS-Cart
    // PharmeLgoRefusals -> /api/5.0/pharme_lgo_refusals). Scope porte par le
    // token client cote serveur : aucun user_id n'est passe par le front.
    GET_REFUSALS: { endpoint: 'lgo_refusals' },
  },
  RMA: {
    GET_DISPUTE_STATUSES: { endpoint: 'dispute_statuses' },
    GET_RMAS: { endpoint: 'rma' },
  },
  SUBSCRIPTION: {
    GET_SUBSCRIPTIONS: { endpoint: 'user_subscriptions' },
  },
  POTS: {
    GET_POTS: { endpoint: 'pots' },
    GET_PULLBACK: { endpoint: 'pots?type=pullback' },
    GET_POTS_DEBIT: { endpoint: 'pot_use' },
  },
  SHIPPING: {
    GET_TRANSITAIRES: { endpoint: 'pms_transitaire' },
  },
  USERS: {
    GET_PROFILE: { endpoint: 'profile' },
    GET_SAVED_CARDS: { endpoint: 'user_saved_cards' },
    GET_WISHLIST: { endpoint: 'wish_list' },
    GET_MANDAT: { endpoint: 'user_mandates' },
    GET_NEWSLETTER: { endpoint: 'newsletters_subscription' },
  },
  IS_IN_MAINTENANCE: {},
} as const
